import { render, staticRenderFns } from "./MyAPlayer.vue?vue&type=template&id=5e09997c&scoped=true&"
import script from "./MyAPlayer.vue?vue&type=script&lang=js&"
export * from "./MyAPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e09997c",
  null
  
)

export default component.exports